const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const UPLOAD_BASE = process.env.REACT_APP_UPLOAD_URL || BASE;

export const API = {
  auth: {
    register: `${BASE}/api/auth/register`,
    login: `${BASE}/api/auth/login`,
  },
  categories: `${BASE}/api/categories`,
  products: `${BASE}/api/products`,
  productById: (id: string) => `${BASE}/api/products/${encodeURIComponent(id)}`,
  productsRecent: `${BASE}/api/products/recent`,
  productsRecentByCategory: (categoryId: string) =>
    `${BASE}/api/products/recent-by-category?categoryId=${encodeURIComponent(categoryId)}&limit=4`,
  banners: `${BASE}/api/banners`,
  sellerProducts: `${BASE}/api/seller-products`,
  siteSettings: {
    welcomeBackground: `${BASE}/api/site-settings/welcome-background`,
    all: `${BASE}/api/site-settings`,
  },
};

export const getImageUrl = (path: string | null | undefined): string => {
  if (!path) return '';
  const b = BASE?.replace(/\/$/, '');
  return path.startsWith('http') ? path : `${b}${path.startsWith('/') ? '' : '/'}${path}`;
};

/** Use for banner (and other upload) images when REACT_APP_UPLOAD_URL is set */
export const getUploadUrl = (path: string | null | undefined): string => {
  if (!path) return '';
  const b = UPLOAD_BASE?.replace(/\/$/, '');
  return path.startsWith('http') ? path : `${b}${path.startsWith('/') ? '' : '/'}${path}`;
};
